module.exports = __webpack_public_path__ + "img/ic_no_timesheet.ed680fb3.svg";